import axios from "axios";

export const BASE_URL = process.env.REACT_APP_SCHEDULER_BASE_URL;

const API = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
    "x-api-key": process.env.REACT_APP_SCHEDULER_API_KEY,
  },
});

const APIFORMDATA = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "multipart/form-data",
    "x-api-key": process.env.REACT_APP_SCHEDULER_API_KEY,
  },
});

// Helper to set Authorization dynamically
export const setAuthHeader = (token) => {
  if (token) {
    API.defaults.headers["Authorization"] = `Bearer ${token}`;
    APIFORMDATA.defaults.headers["Authorization"] = `Bearer ${token}`;
  } else {
    delete API.defaults.headers["Authorization"];
    delete APIFORMDATA.defaults.headers["Authorization"];
  }
};

// Add basic error handling interceptor
const errorInterceptor = (error) => {
  if (!error.response) {
    console.error("Network Error: No response from server.");
    return Promise.reject(new Error("Network Error: No response from server."));
  }
  console.error("API Error:", error.response.data);
  return Promise.reject(error.response.data);
};

API.interceptors.response.use((response) => response, errorInterceptor);
APIFORMDATA.interceptors.response.use((response) => response, errorInterceptor);

export { API, APIFORMDATA };
